var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout-footer mt15"},[_c('div',{staticClass:"layout-footer-warp"},[_c('div',[_vm._v("vue-prev-admin，Made by lyt with ❤️")]),_c('div',{staticClass:"mt5"},[_vm._v(_vm._s(_vm.$t('message.login.copyright.one5')))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }